var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCameraBackground = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "#666666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.05 55V73C80.05 73.8333 79.7583 74.5417 79.175 75.125C78.5917 75.7083 77.8833 76 77.05 76H51.05C50.2167 76 49.5083 75.7083 48.925 75.125C48.3417 74.5417 48.05 73.8333 48.05 73V55C48.05 54.1667 48.3417 53.4583 48.925 52.875C49.5083 52.2917 50.2167 52 51.05 52H56.55L57.3 49.9375C57.4667 49.5625 57.675 49.2292 57.925 48.9375C58.2167 48.6458 58.55 48.4167 58.925 48.25C59.3 48.0833 59.6958 48 60.1125 48H67.9875C68.6125 48 69.175 48.1875 69.675 48.5625C70.175 48.8958 70.55 49.3542 70.8 49.9375L71.55 52H77.05C77.8833 52 78.5917 52.2917 79.175 52.875C79.7583 53.4583 80.05 54.1667 80.05 55ZM69.3625 69.3125C70.8208 67.8542 71.55 66.0833 71.55 64C71.55 61.9167 70.8208 60.1458 69.3625 58.6875C67.9042 57.2292 66.1333 56.5 64.05 56.5C61.9667 56.5 60.1958 57.2292 58.7375 58.6875C57.2792 60.1458 56.55 61.9167 56.55 64C56.55 66.0833 57.2792 67.8542 58.7375 69.3125C60.1958 70.7708 61.9667 71.5 64.05 71.5C66.1333 71.5 67.9042 70.7708 69.3625 69.3125ZM67.925 60.125C69.0083 61.2083 69.55 62.5 69.55 64C69.55 65.5 69.0083 66.7917 67.925 67.875C66.8417 68.9583 65.55 69.5 64.05 69.5C62.55 69.5 61.2583 68.9583 60.175 67.875C59.0917 66.7917 58.55 65.5 58.55 64C58.55 62.5 59.0917 61.2083 60.175 60.125C61.2583 59.0417 62.55 58.5 64.05 58.5C65.55 58.5 66.8417 59.0417 67.925 60.125Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.05 78.6875H79.95V80.25H48.05V78.6875Z",
    fill: "#FAFAFA"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCameraBackground, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/camera-background.0850b450.svg";
export { ForwardRef as ReactComponent };